export default {"src":"/_next/static/image/public/close.5fd4bdfadcd3f31d14730ca0bcdabba7.svg","height":34,"width":34};